const data = {
  id: "workers_childcare",
  title: "Worker Rights & Child Care",
  intro: "The jobs are here. The wages aren't. Neither is the childcare. What Huntsville's labor market looks like from the bottom up — not the chamber of commerce press release.",
  tabs: [
    {
      id: "worker_rights",
      label: "Worker Rights",
      stats: [],
      issues: [],
      trail: []
    },
    {
      id: "child_care",
      label: "Child Care",
      stats: [],
      issues: [],
      trail: []
    },
    {
      id: "pay_clock",
      label: "Pay Clock",
      stats: [],
      issues: [],
      trail: []
    }
  ]
};
export default data;
